import React from "react"
import { ModelErrorMessage } from "./model-error-fallback"

interface Props {
  children: React.ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

export class ModelErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Model loading error caught by boundary:", error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <>
          {this.props.children}
          <ModelErrorMessage
            message={
              this.state.error?.message.includes("404") ||
              this.state.error?.message.includes("Failed to fetch")
                ? "One or more 3D model files could not be found. Please ensure all GLB files are in the /public/models/ directory."
                : "There was an error loading the 3D models. Please refresh the page or check the console for details."
            }
          />
        </>
      )
    }

    return this.props.children
  }
}
